import { clsx } from "clsx";

export default function TextHeaderSmall({
  children,
  className,
}: React.PropsWithChildren<{
  children: React.ReactNode;
  className?: string;
}>) {
  return (
    <div
      className={clsx(
        "mb-4 text-[28px]/[34px] font-medium lg:text-[34px]/[44px]",
        className,
      )}
    >
      {children}
    </div>
  );
}
